import { render } from "./RoomSection.vue?vue&type=template&id=254791cc&scoped=true"
import script from "./RoomSection.vue?vue&type=script&lang=js"
export * from "./RoomSection.vue?vue&type=script&lang=js"

import "./RoomSection.vue?vue&type=style&index=0&id=254791cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254791cc"]])

export default __exports__